module.exports = __webpack_public_path__ + "img/ext-06.246c4d8d.jpg";